/**
 * Vue 3 全局指令插件
 * 自动注册所有自定义指令
 */
import motion from '@/compositions/directives/motion'

export default {
  install(app) {
    // 注册转场动画指令
    app.directive('motion', motion)

    // 如果有其他指令,可以在这里继续注册
    // app.directive('other-directive', otherDirective)
  }
}
